import { useQuery } from '@tanstack/react-query';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { apiClient } from '@/lib/api-client';
import { CardShell } from '../cards/card-shell';
import { formatBrl } from './format';

/**
 * KPI: total e count de pagamentos com status='overdue'. CTA leva para
 * a lista com filtro status=overdue.
 */
export function SummaryPagamentosAtrasadosWidget() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['financial', 'stats', 'summary'],
    queryFn: () => apiClient.financialStatsSummary(),
    staleTime: 1000 * 60,
  });

  const total = data?.pagamentosAtrasados.total ?? 0;
  const count = data?.pagamentosAtrasados.count ?? 0;
  const hasItems = count > 0;

  return (
    <CardShell title="Pagamentos atrasados" icon={AlertTriangle}>
      <div className="flex w-full flex-col items-start gap-2">
        {isLoading ? (
          <div className="flex w-full flex-col gap-2">
            <div className="h-10 w-32 animate-pulse rounded bg-[var(--surface-muted)]" />
            <div className="h-3 w-24 animate-pulse rounded bg-[var(--surface-muted)]" />
          </div>
        ) : isError ? (
          <p className="text-xs text-[var(--fg-muted)]">
            Não foi possível carregar.
          </p>
        ) : (
          <>
            <span className="text-3xl font-semibold tracking-tight tabular-nums text-red-500">
              {formatBrl(total)}
            </span>
            <div className="flex w-full items-center justify-between">
              <p className="text-[11px] text-[var(--fg-muted)]">
                {count} lançamento{count === 1 ? '' : 's'}
              </p>
              {hasItems && (
                <Link
                  to="/escritorio/financeiro?status=overdue"
                  className="text-[11px] font-medium text-[var(--accent)] hover:opacity-90"
                >
                  Mostrar
                </Link>
              )}
            </div>
          </>
        )}
      </div>
    </CardShell>
  );
}
